import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';
import Paginator from "../../components/Paginator";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
import { AiFillEdit, AiFillDelete,AiOutlineReload } from "react-icons/ai";
const PrnRequest = ()=>{
    const [prnRequest, setPrnRequest] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    useEffect(() => {
        (
        async () => {

            const {data} = await axios.get(`prnRequest?page=${page}`);
            setPrnRequest(data.data);
            setLastPage(data.meta.last_page)

        }
        )();
    },[page]);
    const del = async (id) =>{
        if(window.confirm("Are you sure you want to delete this record?")){
            await axios.delete(`prnRequest/${id}`);
            setPrnRequest(prnRequest.filter((prnRequest) => prnRequest.id !== id));
        }
    }

    const retryPayment = async (id) =>{
        if(window.confirm("Are you sure you want to RETRY this payment?")){
            await axios.get(`payRetry/${id}`);
             
        }
    }
    return (
        <Wrapper pageTitle={'PrnRequest'}>
            <InnerNav createLink={'/prnRequestCreate'} listLink={'/prnRequest'} />
                <div className="w-full overflow-hidden rounded-lg shadow-xs">
                    <div className="w-full overflow-x-auto">
                        <table className="w-full whitespace-no-wrap">
                            <thead>
                                <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800" >
                                    <th className="px-4 py-3">#Ref </th>
                                    <th className="px-4 py-3">Trans Date </th>
                                    <th className="px-4 py-3">Amount </th>
                                    <th className="px-4 py-3">Tax Type </th>
                                    <th className="px-4 py-3">PRN </th>
                                    <th>KRA</th> 
                                    <th>Safaricom</th>
                                    <th className="px-4 py-3">TRX CODE </th>
                                     <th className="px-4 py-3">Action</th>
                                </tr>
                                </thead>
                                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800" >
                                    {prnRequest.map((prnRequest)=>{
                                         return(
                                             <tr key={prnRequest.id} className={`text-gray-700 dark:text-gray-400 ${!prnRequest.prn ? 'bg-gray-200' : ''}`}>
                                                 <td className="px-4 py-5">{prnRequest.id}</td>
                                                 <td className="px-4 py-3 text-sm">{prnRequest.transDate}</td>
                                                 <td className="px-4 py-3 text-sm">{prnRequest.amount}</td>
                                                 <td className="px-4 py-3 text-sm">{prnRequest.taxType}</td>
                                                 <td className="px-4 py-3 text-sm">{prnRequest.prn ? prnRequest.prn : 'null'}</td>
                                                 <td className="px-4 py-3 text-sm">{prnRequest.responseCode ? prnRequest.responseCode + "{" : ''}  {prnRequest.message ? prnRequest.message + "}" : ''}</td>
                                                 <td className="px-4 py-3 text-sm">{prnRequest.resultCode ? prnRequest.resultCode + "{" : ''}   {prnRequest.resultDesc ? prnRequest.resultDesc + '}' : ''} </td>
                                                 <td className="px-4 py-3 text-sm">{prnRequest.trxCode}</td>
                                                 <td className="flex px-4 py-3 text-sm">
                                                 {prnRequest.prn ? (
                <button className="btn btn-sm btn-outline-secondary px-5">
                  <AiOutlineReload className="mr-2" onClick={() => retryPayment(prnRequest.id)} /> Retry Payment
                </button>
              ) : (
                <>
                  <Link className="btn btn-sm btn-outline-secondary px-5" to={`/prnRequest/${prnRequest.id}/edit`}>
                    <AiFillEdit /> 
                  </Link>
                  <span className="btn btn-sm btn-outline-secondary" onClick={() => del(prnRequest.id)}>
                    <AiFillDelete className="text-rose-500 text-lg" />
                  </span>
                </>
              )}
                                                    </td>
                                             </tr>
                                         );
                                     })
                                 }
                            </tbody>
                        </table>
                    </div>
                    <Paginator lastPage={lastPage} pageChanged={setPage} />
                </div>
             </Wrapper>
         );
};
export default PrnRequest;